const isAllowed = (currentAccessRights, requiredAccess) => {
  const accessRightsArray = Array.isArray(currentAccessRights) ? currentAccessRights : [currentAccessRights];
  const validationArray = Array.isArray(requiredAccess) ? requiredAccess : [requiredAccess];
  const allow = accessRightsArray.some(access => validationArray.includes(access));
  return allow;
};

export default { isAllowed };
